import * as React from 'react';
import clsx from 'clsx';
import {
	ChevronDown,
	ChevronLeft,
	ChevronRight,
	ChevronUp,
} from 'lucide-react';
import { Typography } from '@/components/common';

export interface ClientSignFieldProgressNavProps {
	completed: number;
	total: number;
	onPrevious: () => void;
	onNext: () => void;
	disabled?: boolean;
	orientation?: 'horizontal' | 'vertical';
	className?: string;
}

export const ClientSignFieldProgressNav: React.FC<
	ClientSignFieldProgressNavProps
> = ({
	completed,
	total,
	onPrevious,
	onNext,
	disabled = false,
	orientation = 'horizontal',
	className,
}) => {
	const isDisabled = disabled || total === 0;
	const PreviousIcon = orientation === 'vertical' ? ChevronUp : ChevronLeft;
	const NextIcon = orientation === 'vertical' ? ChevronDown : ChevronRight;

	return (
		<div className={clsx('flex items-center gap-2 shrink-0', className)}>
			<Typography type="semibold-14" className="text-black whitespace-nowrap">
				{completed} of {total} completed
			</Typography>
			{orientation === 'vertical' ? <span className="flex-1" /> : null}
			<button
				type="button"
				aria-label="Previous field"
				disabled={isDisabled}
				onMouseDown={(event) => event.preventDefault()}
				onClick={onPrevious}
				className="flex size-7 items-center justify-center rounded disabled:opacity-30 hover:bg-grey-5"
			>
				<PreviousIcon className="size-5 text-black" />
			</button>
			<button
				type="button"
				aria-label="Next field"
				disabled={isDisabled}
				onMouseDown={(event) => event.preventDefault()}
				onClick={onNext}
				className="flex size-7 items-center justify-center rounded disabled:opacity-30 hover:bg-grey-5"
			>
				<NextIcon className="size-5 text-black" />
			</button>
		</div>
	);
};
